import type { ReactNode } from "react";

type Props = {
	label: string;
	value: string;
	sub?: string;
	valueClassName?: string;
	editable?: boolean;
};

export const KpiCard = ({
	label,
	value,
	sub,
	valueClassName = "",
	editable,
}: Props) => {
	return (
		<div className='campaign-detail__kpi-card'>
			<div className='campaign-detail__kpi-label'>
				<span>{label}</span>
				{editable && (
					<button type='button' className='campaign-detail__kpi-edit' disabled>
						Edit
					</button>
				)}
			</div>
			<div className={`campaign-detail__kpi-value ${valueClassName}`}>{value}</div>
			{sub && <div className='campaign-detail__kpi-sub'>{sub}</div>}
		</div>
	);
};

export const KpiStrip = ({ children }: { children: ReactNode }) => (
	<div className='campaign-detail__kpi-grid'>{children}</div>
);
